import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/filiais',
    name: 'rota-filiais',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Filiais',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Filiais',
      icon: 'store-alt',
    },
    component: () => import(/* webpackChunkName: "filiais" */ '../views/filiais/Filiais.vue'),
  },
  {
    path: '/administrativo/filiais/cadastro',
    name: 'rota-filiais-cadastro',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Cadastro de filiais',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "filiais" */ '../views/filiais/cadastro/FiliaisCadastro.vue'),
  },
  {
    path: '/administrativo/filiais/:id',
    name: 'rota-filiais-alteracao',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Alteração de filiais',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "filiais" */ '../views/filiais/cadastro/FiliaisCadastro.vue'),
  },
]
